import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import TermsLibraryComponent from '../components/terms-library.component';
import { selectTermsLibrariesQueryItems } from '../../../../../../redux/terms-libraries/selector';
import { termsLibraries } from '../../../../../../redux/terms-libraries/action';
import { sections } from '../../../../../../redux/sections/action';
import { selectSectionsListItems } from '../../../../../../redux/sections/selector';
import { selectListItems } from '../../../../../../redux/library/selector';


const ManagementTermsLibrary = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const parmas: any = useParams()
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [isQuery, setIsQuery] = useState<boolean>(false)
    const termsLibraryQuery = useSelector(selectTermsLibrariesQueryItems)
    const sectionListData = useSelector(selectSectionsListItems)
    const libraryData = useSelector(selectListItems)
    const [
        selectedTermsLibraries,
        setSelectedTermsLibraries
    ] = useState<any>([])

    const fetchTermsLibraryQueryById = () => {
        dispatch(termsLibraries.query({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/contract/terms-libraries/query`, entity: 'termsLibraries', jsonData: {

                Records: [
                    {
                        "Id": parmas?.id
                    }
                ]

            }
        })).then(() => {
            setIsQuery(true)
        }).then(() => {
            setIsLoading(false)
        })




    }

    const handleInnerbasicFormChange: any = (event: any, field: string) => {
        setSelectedTermsLibraries((prevState) => ({
            ...prevState,
            [field]: event,
        }));
    }



    useEffect(
        () => {
            dispatch(sections.list({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/contract/sections/list`, entity: 'sections', jsonData: {} }))
            if (parmas?.id > 0) {
                fetchTermsLibraryQueryById()
                setIsLoading(false)
            } else {
                setIsLoading(false)
            }
        },
        []
    )
    useEffect(
        () => {

            if (isQuery) {
                setSelectedTermsLibraries(termsLibraryQuery?.result?.items)

            }
        },
        [isQuery]
    )

    const handleFormSubmit = async (event: any) => {
        event.preventDefault();

        if (parmas?.id > 0) {
            dispatch(termsLibraries.update({
                url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/contract/terms-libraries`, entity: 'termsLibraries', jsonData: {

                    Records: [
                        selectedTermsLibraries

                    ]

                }
            })).then(() => {
                back()
            })

        } else {
            dispatch(termsLibraries.create({
                url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/contract/terms-libraries`, entity: 'termsLibraries', jsonData: {

                    Records: [
                        selectedTermsLibraries
                    ]

                }
            })).then(() => {
                back()
            })
        }

    }

    const back = () => {
        navigate('/management/e-applications/contract/terms-libraries')
    }


    return (
        <>
            {isLoading ? <PageLoader /> :
                <TermsLibraryComponent
                    sections={sectionListData?.result?.items}
                    termsNameLibrary={libraryData?.result?.TermsNameLibrary}
                    selectedTermsLibraries={selectedTermsLibraries}
                    onInnerBasicFormChange={handleInnerbasicFormChange}
                    back={back}
                    handleFormSubmit={handleFormSubmit}
                />
            }

        </>
    )

}

export default ManagementTermsLibrary;